<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-envelope"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Forgot password?</h2>
                <p>Enter your registered email address and we'll send you instructions to reset your password.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-envelope"></i><span>Secure email verification</span></li>
                    <li><i class="fa fa-shield"></i><span>Protected account recovery</span></li>
                    <li><i class="fa fa-clock-o"></i><span>Quick reset process</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="passwordForm" class="login-form" autocomplete="off" (ngSubmit)="resetPassword()">
                <h1 class="login-title">Reset password</h1>
                <p class="login-subtitle">We'll email you a link to create a new password.</p>

                <div class="login-field">
                    <label for="forgotEmail">Email</label>
                    <input type="text" class="login-input" formControlName="email" id="forgotEmail"
                        placeholder="Email" autocomplete="off">
                    <div *ngIf="isSubmitted">
                        <span class="login-error"
                            *ngIf="!passwordForm.get('email').dirty && passwordForm.get('email').errors?.required">Email Required</span>
                        <span class="login-error"
                            *ngIf="passwordForm.get('email').dirty && passwordForm.get('email').errors">Invalid Email</span>
                    </div>
                </div>

                <re-captcha #invisible (resolved)="resolved($event)" size="invisible" [siteKey]="recaptchaSiteKey"></re-captcha>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit">RESET PASSWORD</button>

                <div class="login-links">
                    <a (click)="signIn()">Sign in</a>
                </div>
            </form>
        </section>
    </div>
</div>
